import { ChangeDetectionStrategy, OnInit, Component, AfterViewInit, Input, EventEmitter, Output } from "@angular/core";
import { ViewerModel } from '../../../models/viewer-model';
import { E5ConfigurationService, ConfigurationScopeService } from 'e5core-angular-services';
import { ViewerBehaviourType } from '../../../enums/viewer-behaviour-type';
import { ViewerDisplayEvent } from '../../../events/viewer-display-event';

@Component({
    selector: 'e5core-ui-email-conversation-viewer',
    template: `
    <span *ngIf="1==+behaviourType">
    <iframe *ngIf="!(conversationViewerUrl == '')" [src]="conversationViewerUrl | safe"></iframe>
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiEmailConversationViewerComponent implements AfterViewInit, OnInit {
    @Input() behaviourType: ViewerBehaviourType;
    @Input() popupWindowFeatures: string;
    @Input() readonly: boolean;
    @Output() viewerDisplayedEvent = new EventEmitter<ViewerDisplayEvent>();

    conversationViewerUrl: string;

    constructor(public e5ConfigurationService: E5ConfigurationService, public configurationScopeService: ConfigurationScopeService) 
    {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
    }

    public showInlineViewer(viewerModel: ViewerModel) {
        this.constructViewerUrl(viewerModel, null);
        this.raiseEvent(viewerModel);
    }

    public showPopViewer(viewerModel: ViewerModel) {
        this.constructViewerUrl(viewerModel, this.performWindowPopup);
    }

    private performWindowPopup(viewerModel: ViewerModel) {
        window.open(viewerModel.fullUrl, 'E5ConversationViewer', viewerModel.features);
        this.raiseEvent(viewerModel);
    }

    public constructViewerUrl(viewerModel: ViewerModel, nextFunction: Function): void {

        // format URL e.g.
        // http://hcfv3dev:84/Web/app/conversation/conversation.view.standalone.html?
        //  workid=c398be5d-e2ea-11e8-9681-005056ba65e4&source=GetNext&
        //  instance=8a97a0dc-ecf9-497f-95cb-42837ea6e4f2&department=66b8d445-b186-41e2-8c0e-661ccfc93ffc

        const documentStoreBaseUrl = this.e5ConfigurationService.settings.apiServer.baseUrl;
        viewerModel.features = this.popupWindowFeatures;

        this.configurationScopeService.get(this.e5ConfigurationService.settings.apiServer.scope).subscribe(
            s => {
                const departmentId = s.siteId;
                const instanceId = s.instanceId;

                const url = documentStoreBaseUrl + // e.g http://hcfv3dev:84
                '/Web/app/conversation/conversation.view.standalone.html' +
                '?workid=' + viewerModel.workId +
                '&source=GetNext' +
                '&instance=' + instanceId +
                '&department=' + departmentId;

                viewerModel.fullUrl = url;

                if (nextFunction) {
                    nextFunction(viewerModel);
                }
            },
            error => {
              console.error(error);
            }
          )
    }

    public raiseEvent(viewerModel: ViewerModel): void {
        this.viewerDisplayedEvent.emit({
            workId: viewerModel.workId,
            type: 'EmailConversation',
            attachmentId: null,
            fullUrl: null,
            name: null});
    }
}